
// import HeaderServices from "@/components/HeaderServices.vue";
// import WaveServ from "@/components/WaveServ.vue";
import Breed from "../components/Breed.vue";
import Formm from "../components/Formm.vue";
import Foot from "@/components/Foot.vue";
import JsonPosts from "../assets/posts_home.json";

export default {
  name: "services",
  data: () => ({
    posts: JsonPosts,
    secPosts: [],
  }),
  components: {
    // HeaderServices,
    // WaveServ,
    Formm,
    Foot,
    Breed,
  },
  methods: {
    servPosts() {
      console.log("run");
      const that = this as any;
      for (let i = 8; i < 16; i++) {
        that.secPosts.push(that.posts[i]);
        // console.log(that.secPosts)
      }
    },
  },
  created() {
    const that = this as any;
    that.servPosts();
  },
};
